import { useTranslation } from "react-i18next";

const ABOUT_IMAGE =
  "https://readdy.ai/api/search-image?query=A%20clean%20top-down%20flat%20lay%20of%20an%20open%20notebook%20with%20handwritten%20notes%20a%20pen%20and%20a%20few%20product%20printouts%20on%20a%20soft%20sage%20green%20desk%20with%20warm%20natural%20light%20and%20airy%20composition&width=1000&height=800&seq=about-visual-v2&orientation=landscape&nocache=true";

const POINTS = [
  { icon: "ri-checkbox-circle-line", title: "about.point1.title", text: "about.point1.text" },
  { icon: "ri-shield-check-line", title: "about.point2.title", text: "about.point2.text" },
  { icon: "ri-share-forward-line", title: "about.point3.title", text: "about.point3.text" },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="order-2 lg:order-1">
          <div className="overflow-hidden rounded-lg border border-background-200">
            <img
              src={ABOUT_IMAGE}
              alt="Organized Basetao Spreadsheet shopping notes and product photos"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-xs font-semibold uppercase tracking-wide text-primary-600">
            {t("about.eyebrow")}
          </span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t("about.title")}
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
            {t("about.p1")}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            {t("about.p2")}
          </p>
        </div>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {POINTS.map((point) => (
          <div
            key={point.title}
            className="rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className={`${point.icon} text-xl`} />
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
              {t(point.title)}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(point.text)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}